module.exports = __webpack_public_path__ + "static/media/title@2x.d1ab6e01.png";